export default "__VITE_ASSET__DpxKzC41__";